import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import { getEmployee, CreateSaveEmployee } from '../../../actions/employees'
import { setLanguage, getLanguageInfos } from '../../../language/actions'

// Components
import Phone from './../../../shared/components/Phone'
import HelpText from '../../../shared/components/HelpText'
import WorkHours from '../../../shared/components/Workhours'
// import NotificationCopy from '../../../shared/components/NotificationCopy'

import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Check from '../../../shared/elements/check'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import DropDown from '../../../shared/elements/dropDown'
import DateTime from '../../../shared/elements/datetime'
import Textarea from '../../../shared/elements/textarea'
import Grid from '../../../shared/elements/grid'
import Divider from '../../../shared/elements/divider'

// Styles
import './view.scss'

// Utils
import { hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../utils/auth'
import { translation, enumtranslate } from '../../../utils/helpers'
import PanelHeader from '../../../shared/elements/panelHeader'

class View extends Component {
  constructor (props) {
    super(props)
    this.state = {
      type: 'edit',
      validate: {
        UsersInitials: true,
        UserName: true,
        Phone: true,
        Email: true
      },
      employee: {
        Id: 0,
        CompanyId: 0,
        Name: '',
        UsersInitials: '',
        UserName: '',
        Phone: '',
        PhoneCode: this.props.phonecode,
        Email: '',
        Note: '',
        Active: true,
        Department: 0,
        ProductionPart: '',
        EmployeeRole: 0,
        StartScreen: '/workscreen',
        ProcessTimeGainFactor: 0,
        IsWageReported: true,
        EmploymentDate: moment(),
        TerminationDate: moment(),
        IgnoreIPRestriction: false,
        CompanyPunchClockActive: false,
        CompanyIPRestriction: false,
        WorkHour: {
          Monday: 0,
          MondayStartTime: null,
          MondayEndTime: null,
          Tuesday: 0,
          TuesdayStartTime: null,
          TuesdayEndTime: null,
          Wednesday: 0,
          WednesdayStartTime: null,
          WednesdayEndTime: null,
          Thursday: 0,
          ThursdayStartTime: null,
          ThursdayEndTime: null,
          Friday: 0,
          FridayStartTime: null,
          FridayEndTime: null,
          Saturday: 0,
          SaturdayStartTime: null,
          SaturdayEndTime: null,
          Sunday: 0,
          SundayStartTime: null,
          SundayEndTime: null
        },
        PauseType: 0,
        MondayPause: 0,
        TuesdayPause: 0,
        WednesdayPause: 0,
        ThursdayPause: 0,
        FridayPause: 0,
        SaturdayPause: 0,
        SundayPause: 0,
        NotificationSettings: [],
        MyWorkscreen: {
          Active: false,
          Step1: false,
          Step2: false,
          Step3: false,
          Step4: false,
          Step5: false,
          Step6: false,
          Step7: false
        }
      },
      dimensions: {
        width: 0,
        height: 0
      }
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onInputLanguageChange = this.onInputLanguageChange.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.onChangeDate = this.onChangeDate.bind(this)
    this.onCheck = this.onCheck.bind(this)
    this.saveAddEmployee = this.saveAddEmployee.bind(this)
    this.addEmployee = this.addEmployee.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }

  componentDidMount () {
    this.getEmployee(this.props)
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps (nextProps) {
    this.getEmployee(nextProps)
  }

  getEmployee (props) {
    if (typeof props.item === 'undefined') return
    if (typeof props.item.UserId !== 'undefined') {
      props.getEmployee(props.item.UserId).then((res) => {
        this.setState({
          type: 'edit',
          employee: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      employee: {
        UserId: 0,
        CompanyId: parseInt(this.props.auth.user.ShopId),
        Name: '',
        UsersInitials: '',
        UserName: '',
        Phone: '',
        PhoneCode: this.props.phonecode,
        Email: '',
        Note: '',
        Active: true,
        Department: 0,
        ProductionPart: 100,
        EmployeeRole: 3,
        StartScreen: '/workscreen',
        ProcessTimeGainFactor: 100,
        IsWageReported: true,
        EmploymentDate: Date.now(),
        TerminationDate: moment(),
        IgnoreIPRestriction: false,
        CompanyPunchClockActive: false,
        CompanyIPRestriction: false,
        WorkHour: {
          Monday: 0,
          MondayStartTime: null,
          MondayEndTime: null,
          Tuesday: 0,
          TuesdayStartTime: null,
          TuesdayEndTime: null,
          Wednesday: 0,
          WednesdayStartTime: null,
          WednesdayEndTime: null,
          Thursday: 0,
          ThursdayStartTime: null,
          ThursdayEndTime: null,
          Friday: 0,
          FridayStartTime: null,
          FridayEndTime: null,
          Saturday: 0,
          SaturdayStartTime: null,
          SaturdayEndTime: null,
          Sunday: 0,
          SundayStartTime: null,
          SundayEndTime: null
        },
        PauseType: 0,
        MondayPause: 0,
        TuesdayPause: 0,
        WednesdayPause: 0,
        ThursdayPause: 0,
        FridayPause: 0,
        SaturdayPause: 0,
        SundayPause: 0,
        NotificationSettings: [],
        MyWorkscreen: {
          Active: false,
          Step1: false,
          Step2: false,
          Step3: false,
          Step4: false,
          Step5: false,
          Step6: false,
          Step7: false,
          Step101: false,
          Step102: false,
          Step103: false,
          Step104: false
        },
        dimensions: {
          width: 0,
          height: 0
        }
      }
    })
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  saveAddEmployee (e) {
    if (this.state.employee.UserId > 0) {
      const propName = typeof e === 'string' ? e : e.target.name
      /**
       * If current prop it returns the new value, else null
       * @param {String} prop Actual prop
       * @param {Any} value New value of prop
       */
      const valueOrNull = (prop, value) => {
        if (typeof propName === 'string') {
          return propName === prop ? value : null
        }
        return value
      }

      /**
       * If dependent props has propName it returns the new value, else null
       * @param {Array<String>} props Dependent props
       * @param {Any} value New value of prop
       */
      const dependentValueOrNull = (props, value) => {
        if (typeof propName === 'string') {
          return props.includes(propName) ? value : null
        }
        return value
      }

      // convert date
      const formatDate = (date) => {
        if (date === null || date === '' || date === undefined) return null
        if (Number.isInteger(date)) date = moment(window.CustomDate(date))
        // console.log('format date:', date.format('YYYY-MM-DDTHH:mm:ss'))
        if (typeof date.format === 'function') {
          return date.format('YYYY-MM-DDTHH:mm:ss')
        }
        return date
      }

      let employee = { ...this.state.employee }
      if (employee.ProductionPart === '' || employee.ProductionPart === null) employee.ProductionPart = 0
      employee.EmploymentDate = formatDate(employee.EmploymentDate)
      employee.TerminationDate = formatDate(employee.TerminationDate)

      let data = {
        Id: employee.Id,
        UserId: employee.UserId,
        CompanyId: employee.CompanyId,
        Name: valueOrNull('Name', employee.Name),
        UsersInitials: valueOrNull('UsersInitials', employee.UsersInitials),
        UserName: valueOrNull('UserName', employee.UserName),
        Phone: valueOrNull('Phone', employee.Phone),
        PhoneCode: valueOrNull('PhoneCode', employee.PhoneCode),
        Email: valueOrNull('Email', employee.Email),
        Note: valueOrNull('Note', employee.Note),
        Active: valueOrNull('Active', employee.Active),
        Department: valueOrNull('Department', employee.Department),
        IsAssignableToOrders: valueOrNull('IsAssignableToOrders', employee.IsAssignableToOrders),
        ProductionPartHasValue: dependentValueOrNull([ 'IsWageReported', 'ProductionPart' ], true),
        ProductionPart: dependentValueOrNull([ 'IsWageReported', 'ProductionPart' ], employee.ProductionPart),
        EmployeeRole: valueOrNull('EmployeeRole', employee.EmployeeRole),
        StartScreen: valueOrNull('StartScreen', employee.StartScreen),
        ProcessTimeGainFactor: valueOrNull('ProcessTimeGainFactor', employee.ProcessTimeGainFactor),
        IsWageReported: dependentValueOrNull([ 'IsWageReported', 'ProductionPart' ], employee.IsWageReported),
        EmploymentDateHasValue: valueOrNull('EmploymentDate', true),
        EmploymentDate: valueOrNull('EmploymentDate', employee.EmploymentDate),
        TerminationDateHasValue: valueOrNull('TerminationDate', true),
        TerminationDate: valueOrNull('TerminationDate', employee.TerminationDate),
        Language: valueOrNull('Language', employee.Language),
        IgnoreIPRestriction: valueOrNull('IgnoreIPRestriction', employee.IgnoreIPRestriction),
        NotificationSettingsHasValue: dependentValueOrNull([ 'Noti_Email', 'Noti_Sms' ], true),
        NotificationSettings: dependentValueOrNull([ 'Noti_Email', 'Noti_Sms' ], employee.NotificationSettings),
        MyWorkscreenHasValue: /(^WorkScreen).*|(^Step).*/.test(propName),
        MyWorkscreen: /(^WorkScreen).*|(^Step).*/.test(propName) ? {
          UserId: employee.MyWorkscreen.UserId,
          [propName]: employee.MyWorkscreen[propName],
          Active: valueOrNull('WorkScreen_Active', employee.MyWorkscreen.Active)
        } : null,
        PermissionsHasValue: valueOrNull('Permissions', true),
        Permissions: valueOrNull('Permissions', employee.Permissions)
      }

      // update
      this.props.CreateSaveEmployee(data).then((res) => {
        this.props.onSave(res.data, this.state.type)
        this.setState({
          employee: res.data
        })
      }, (err) => {
        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
          let errors = err.response.data.Errors
          let errorText = ''
          errors.map((item) => {
            if (item.DictionaryKey !== 0) {
              errorText += '<br />' + translation(item.DictionaryKey)
            }
          })
          // Toastr
          window.toastr.error(translation(errorText), translation('216'))
        } else {
          const errorMessage = (error) => {
            let messageText = ''
            if (error < 5) {
              messageText += translation('16334')
            }
            switch (error) {
              case 1:
                messageText += translation('16329')
                break
              case 2:
                messageText += translation('16336')
                break
              case 3:
                messageText += translation('16335')
                break
              case 4:
                messageText += translation('16338')
                break
              case 5:
                messageText += translation('16337')
                break
              default:
                break
            }
            messageText += '<br>'
            return messageText
          }
          let errors = err.response.data
          if (Array.isArray(errors)) {
            let message = errors.map(error => errorMessage(error))
            window.toastr.error(message, translation('216'))
          } else {
            // Toastr
            window.toastr.error(translation('1883'), translation('216'))
          }
        }
      })
    }
  }

  addEmployee () {
    if (this.state.employee.UserId === 0) {
      // convert date
      const formatDate = (date) => {
        if (date === null || date === '' || date === 0 || date === undefined) return null
        if (Number.isInteger(date)) date = moment(window.CustomDate(date))
        // console.log(date.format('YYYY-MM-DDTHH:mm:ss'))
        if (typeof date.format === 'function') {
          return date.format('YYYY-MM-DDTHH:mm:ss')
        }
        return date
      }
      let employee = { ...this.state.employee }
      employee.EmploymentDate = formatDate(employee.EmploymentDate)
      employee.TerminationDate = formatDate(employee.TerminationDate)

      // update
      this.props.CreateSaveEmployee(employee).then((res) => {
        this.props.onSave(res.data, this.state.type)
        this.setState({
          employee: res.data
        })
      }, (err) => {
        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
          let errors = err.response.data.Errors
          let errorText = ''
          errors.map((item) => {
            if (item.DictionaryKey !== 0) {
              errorText += '<br />' + translation(item.DictionaryKey)
            }
          })
          // Toastr
          window.toastr.error(translation(errorText), translation('216'))
        } else {
          // Toastr
          window.toastr.error(translation('1883'), translation('216'))
        }
      })
      // } else {
      //   console.log('validation error')
      // }
    }
  }

  onInputChange (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (typeof e === 'undefined') {
        e = name
      }
      name = e.target.name
      value = e.target.value
    }

    this.setState({
      employee: {
        ...this.state.employee,
        [name]: value
      }
    }, () => {
      if (name === 'StartScreen' || name === 'EmployeeRole' || name === 'Department') {
        this.saveAddEmployee(name)
      }
    })
  }

  onInputLanguageChange (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (typeof e === 'undefined') {
        e = name
      }
      name = e.target.name
    }

    let langInfos = this.props.getLanguageInfos()
    langInfos.map((l) => {
      if (l.SelfLangName === e.target.value) {
        value = l.LanguageName
      }
    })

    if (this.state.employee.UserId === this.props.auth.user.UserId) {
      this.props.setLanguage(value)
    }

    this.setState({
      employee: {
        ...this.state.employee,
        [name]: value
      }
    }, () => {
      if (name === 'Language') {
        this.saveAddEmployee(name)
      }
    })
  }
  onRadioChange (e) {
    e.persist()
    let value = e.target.checked
    let name = e.target.name
    if (name === 'WorkScreen_Active') {
      let workscreen = this.state.employee.MyWorkscreen
      workscreen.Active = value
      this.setState({
        employee: {
          ...this.state.employee,
          MyWorkscreen: workscreen
        }
      }, () => {
        this.saveAddEmployee(e)
      })
    } else {
      this.setState({
        employee: {
          ...this.state.employee,
          [name]: value
        }
      }, () => {
        this.saveAddEmployee(e)
      })
    }
  }

  onPhoneChange (name, e) {
    let value = ''
    value = name.target.value
    if (name.target.name === 'PhoneNumber') {
      name = 'Phone'
      this.setState({
        employee: {
          ...this.state.employee,
          [name]: value
        }
      })
    } else {
      this.setState({
        employee: {
          ...this.state.employee,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      }, () => { this.saveAddEmployee(name) })
    }
  }

  onChangeDate (name, e) {
    let value = e
    this.setState({
      employee: {
        ...this.state.employee,
        [name]: value
      }
    }, () => {
      this.saveAddEmployee(name)
    })
  }

  onCheck (e) {
    e.persist()
    var employee = { ...this.state.employee }
    if (e.target.name.substring(0, 4) === 'Step') {
      let field = e.target.name
      let value = e.target.checked
      let workscreen = this.state.employee.MyWorkscreen
      workscreen[field] = value
      this.setState({
        employee: {
          ...employee,
          MyWorkscreen: workscreen
        }
      }, () => {
        this.saveAddEmployee(e)
      }
      //, console.log(this.state.employee)
      )
    } else {
      // check if set
      var set = false
      var array = [...this.state.employee.NotificationSettings]
      array.map(function (val, key) {
        // console.log('Checked: ', key, val)
        if (val.NotificationEvent === Number(e.target.value)) {
          set = true
          if (e.target.name === 'Noti_Sms') {
            array[key].Sms = e.target.checked
          } else if (e.target.name === 'Noti_Email') {
            array[key].Email = e.target.checked
          }
        }
      })
      // if not set - add object
      if (set === false) {
        var newItem = {}
        if (e.target.name === 'Noti_Sms') {
          newItem = {
            NotificationEvent: Number(e.target.value),
            Sms: e.target.checked,
            Email: false
          }
        } else if (e.target.name === 'Noti_Email') {
          newItem = {
            NotificationEvent: Number(e.target.value),
            Sms: false,
            Email: e.target.checked
          }
        }
        array.push(newItem)
        // if set change
      }
      this.setState({
        employee: {
          ...employee,
          NotificationSettings: array
        }
      }, () => this.saveAddEmployee(e))
    }
  }

  renderUser () {
    let employee = { ...this.state.employee }
    /* const ActiveChecked = (type, active) => {
      if (active === type) {
        return (
          true
        )
      }
    } */
    return (
      <Panel title={translation('64')}>
        <Text name='Name' value={employee.Name || ''} onChange={this.onInputChange} onBlur={this.saveAddEmployee} labelText={translation('30')} />
        <Text name='UsersInitials' value={employee.UsersInitials || ''} maxLength={2} onChange={this.onInputChange} onBlur={this.saveAddEmployee} labelText={translation('1815')} helpText={translation('1964')} />
        <Text name='UserName' value={employee.UserName || ''} onChange={this.onInputChange} onBlur={this.saveAddEmployee} labelText={translation('1')} helpText={translation('1965')} />

        <LabelWrapper labelText={translation('38')}>
          <Phone
            onChange={this.onPhoneChange}
            onBlur={() => this.saveAddEmployee('Phone')}
            code={employee.PhoneCode}
            number={employee.Phone} />
        </LabelWrapper>

        <Text name='Email' value={employee.Email || ''} onChange={this.onInputChange} onBlur={this.saveAddEmployee} labelText={translation('1052')} />

        <Textarea name='Note' onChange={this.onInputChange} onBlur={this.saveAddEmployee} value={employee.Note || ''} placeholder={translation('2260')} labelText={translation('93')} />
        {/* <LabelWrapper labelText={translation('93')}>
          <textarea name='Note' onChange={this.onInputChange} onBlur={this.saveAddEmployee} value={employee.Note || ''} placeholder={translation('2260')} />
        </LabelWrapper> */}

        <Switch name='Active' onChange={this.onRadioChange} checked={this.state.employee.Active} labelText={translation('295')} helpText={translation('1967')} />
      </Panel>
    )
  }

  renderSettings () {
    if (!hasSubscriptionPermission(this.props.auth, 10, 0) || typeof this.props.employeeTypes === 'undefined') return null
    if (Object.keys(this.props.employeeTypes).length === 0) return null
    let employee = this.state.employee
    let EmploymentDate = this.state.employee.EmploymentDate
    let TerminationDate = this.state.employee.TerminationDate

    let langInfos = this.props.getLanguageInfos()

    // Date
    let renderEmploymentDate = ''
    if (typeof EmploymentDate !== 'undefined' && EmploymentDate !== null && EmploymentDate !== '') {
      renderEmploymentDate = window.CustomDate(EmploymentDate)
    }

    let renderTerminationDate = ''
    if (typeof TerminationDate !== 'undefined' && TerminationDate !== null && TerminationDate !== '') {
      renderTerminationDate = window.CustomDate(TerminationDate)
    }

    const ActiveChecked = (type, active) => {
      if (active === type) {
        return (
          true
        )
      }
    }

    const EmployeeTypesList = (val, key) => {
      return (
        <option key={key} value={key + 1}>{translation(val)}</option>
      )
    }

    const CompanyDepartmentList = (val, key) => {
      return (
        <option key={key} value={key}>{translation(val)}</option>
      )
    }

    const langInfosList = (val, key) => {
      return (
        <option key={key} value={val.SelfLangName}>{translation(val.SelfLangName)}</option>
      )
    }

    const GetSelfLanguage = (allLanguages, currentLanguage) => {
      let defaultLanguage
      allLanguages.map((l) => {
        if (l.LanguageName === currentLanguage) {
          defaultLanguage = l.SelfLangName
        }
      })
      return defaultLanguage
    }

    let employeeTypes = []
    for (var i = 1; i < Object.keys(this.props.employeeTypes).length + 1; i++) {
      employeeTypes.push(this.props.employeeTypes[i])
    }

    let companyDepartments = []
    for (i = 0; i < Object.keys(this.props.companyDepartments).length; i++) {
      companyDepartments.push(this.props.companyDepartments[i])
    }

    let disableCompanyDepartment = true
    if (this.props.auth.user.UserType === 3 && this.state.employee.Permissions !== undefined) {
      for (i = 0; i < this.state.employee.Permissions.length; i++) {
        if (this.state.employee.Permissions[i].Id === 9 && this.state.employee.Permissions[i].Checked) {
          disableCompanyDepartment = false
        }
      }
    } else if (this.props.auth.user.UserType === 7) {
      disableCompanyDepartment = false
    }

    let inputProps = {
      readOnly: true
    }

    // console.log('auth', this.props.auth)
    let showDepartment = this.props.auth.departmentType === 2 // both

    let gainFactor = ''
    if (hasSubscriptionPermission(this.props.auth, 20, 17)) {
      gainFactor = (
        <Text
          name='ProcessTimeGainFactor'
          value={employee.ProcessTimeGainFactor || ''}
          onChange={this.onInputChange}
          onBlur={this.saveAddEmployee}
          labelText={translation('13484')}
          helpText={translation('1976')}
        />
      )
    }

    // startScreens
    let startScreens = [
      { DictionaryKey: '18', value: '/workscreen' },
      { DictionaryKey: '683', value: '/orders' },
      { DictionaryKey: '1887', value: '/mypage' },
      { DictionaryKey: '6', value: '/settings' },
      { DictionaryKey: '10', value: '/employees' },
      { DictionaryKey: '14', value: '/customers' },
      { DictionaryKey: '1172', value: '/prices' },
      { DictionaryKey: '437', value: '/punchclock' },
      { DictionaryKey: '448', value: '/punchreport' }
    ]

    // Return
    return (
      <Panel title={translation('6')}>
        <LabelWrapper labelText={translation('60')}>
          <DropDown name='EmployeeRole' onChange={this.onInputChange} value={employee.EmployeeRole}>
            {employeeTypes.map(EmployeeTypesList)}
          </DropDown>
        </LabelWrapper>

        {showDepartment && (
          <LabelWrapper labelText={translation('626')}>
            <DropDown name='Department' onChange={this.onInputChange} value={employee.Department} disabled={disableCompanyDepartment}>
              {companyDepartments.map(CompanyDepartmentList)}
            </DropDown>
          </LabelWrapper>
        )}

        <LabelWrapper labelText={translation('56')}>
          <DropDown name='StartScreen' onChange={this.onInputChange} value={employee.StartScreen}>
            {startScreens.map((v, k) => {
              return <option key={k} value={v.value}>{translation(v.DictionaryKey)}</option>
            })}
          </DropDown>
        </LabelWrapper>

        <Switch name='IsAssignableToOrders' onChange={this.onRadioChange} checked={employee.IsAssignableToOrders} labelText={translation('18325')} />

        {hasSubscriptionPermission(this.props.auth, 20) && (
          <Text
            name='ProductionPart'
            value={employee.ProductionPart}
            onChange={this.onInputChange}
            onBlur={this.saveAddEmployee}
            disabled={ActiveChecked(false, employee.IsWageReported)}
            labelText={translation('967')}
            helpText={ActiveChecked(false, employee.IsWageReported) ? translation('14878') : translation('1975')}
          />
        )}

        {gainFactor}

        {hasSubscriptionPermission(this.props.auth, 30) && (
          <Switch name='IsWageReported' onChange={this.onRadioChange} checked={employee.IsWageReported} labelText={translation('1816')} />
        )}

        <DateTime
          inputProps={inputProps}
          dateFormat='DD-MM-YYYY'
          closeOnSelect
          timeFormat={false}
          value={renderEmploymentDate}
          onChange={this.onChangeDate.bind(this, 'EmploymentDate')}
          labelText={translation('1504')} />

        <DateTime
          dateFormat='DD-MM-YYYY'
          closeOnSelect
          timeFormat={false}
          value={renderTerminationDate}
          onChange={this.onChangeDate.bind(this, 'TerminationDate')}
          labelText={translation('1505')} />

        <LabelWrapper labelText={translation('1711')}>
          <DropDown name='Language' onChange={this.onInputLanguageChange} value={GetSelfLanguage(langInfos, employee.Language)}>
            {langInfos.map(langInfosList)}
          </DropDown>
          {/* <select name='Language'
            onChange={this.onInputLanguageChange}
            value={GetSelfLanguage(langInfos, employee.Language)}>
            {langInfos.map(langInfosList)}
          </select> */}
        </LabelWrapper>

        {employee.CompanyPunchClockActive && (
          <Switch name='IgnoreIPRestriction' checked={employee.IgnoreIPRestriction}
            onChange={this.onRadioChange} disabled={!employee.CompanyIPRestriction}
            labelText={translation('16680')} />
        )}
      </Panel>
    )
  }

  renderHours () {
    // if (this.state.type === 'create') return null
    if (!hasSubscriptionPermission(this.props.auth, 10, 0)) return null

    const setWorkHours = (data) => {
      this.setState({
        employee: {
          ...this.state.employee,
          WorkHour: data
        }
      })
    }

    return <WorkHours LogCount={this.state.employee.LogCount} setWorkHours={setWorkHours} WorkHours={this.state.employee.WorkHour} onlyShow displayId={1} />
  }

  renderNotifications () {
    // if (this.state.type === 'create') return null
    if (this.props.notificationEventType === undefined || this.props.notificationEventType === null || this.props.notificationEventType.length === 0) {
      return
    }
    let employee = this.state.employee
    if (employee.NotificationSettings.length === 0) return null
    var checkedSms = []
    var checkedEmail = []
    employee.NotificationSettings.map((val, k) => {
      checkedSms[val.NotificationEvent] = val.Sms
      checkedEmail[val.NotificationEvent] = val.Email
    })
    const NotificationEventTypeList = (val, key) => {
      // if (val.NotificationEvent >= 100) {
      //   return
      // }
      // If inherited from premium partner, hide notification
      let forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1 // Forsi is available for the company
      if (val.NotificationEvent === 9 && (!hasSubscriptionPermission(this.props.auth, 20) || !forsiEnable)) {
        return
      }
      // hide DeliveryTimeChange for body shop in the section Referred orders. (*** temporary ***)
      if (val.NotificationEvent === 23 && this.props.auth.departmentType === 1) {
        return
      }
      let key2 = val.NotificationEvent
      // console.log('Notif. key: ', translation(val).substring(0, 8), key, 'sms:' + checkedSms[key], 'mail:' + checkedEmail[key])
      let helptext = ''
      let labelText = ''
      switch (key2) {
        case 1:
          if (this.props.auth.departmentType === 0) {
            helptext = '2169'
          } else {
            helptext = '15349'
            labelText = '15348'
          }
          break
        case 2:
          helptext = '2170'
          break
        case 3:
        case 22:
          helptext = '2171'
          break
        case 4:
        case 24:
          helptext = '2198'
          break
        case 5:
        case 25:
          helptext = '2172'
          break
        case 6:
        case 26:
          helptext = '2173'
          break
        case 7:
          helptext = '1969'
          break
        case 8:
          helptext = '1970'
          break
        case 9:
          helptext = '1971'
          break
        case 10:
          helptext = '1972'
          break
        case 11:
          helptext = '1973'
          break
        case 12:
          helptext = '2197'
          break
        case 13:
          if (this.props.auth.departmentType === 1) helptext = '15346'
          else helptext = '2196'
          break
        case 27:
          helptext = '2196'
          break
        case 29:
          helptext = '17978'
          break
        case 14:
          helptext = '13709'
          break
        case 16:
          helptext = '15075'
          break
        case 17:
          helptext = '15174'
          break
        case 18:
        case 23:
          if (this.props.auth.departmentType === 1) helptext = '15173'
          else helptext = '15150'
          break
        case 19:
          helptext = '15236'
          break
        case 20:
          helptext = '15349'
          break
        case 21:
          helptext = '15073'
          break
        case 100:
          helptext = '2169'
          break
        case 102:
          helptext = '15023' // '2170'
          break
        case 103:
          helptext = '2171'
          break
        case 104:
          helptext = '15024' // '2198'
          break
        case 105:
          helptext = '2172'
          break
        case 106:
          helptext = '2173'
          break
        case 108:
          helptext = '15022'
          break
        case 150:
          helptext = '17958'
      }
      return (
        <Grid cols={[ 4 ]} align='center' key={key} spacing={1}>
          <span>{translation(labelText || enumtranslate('NotificationEventType', val.NotificationEvent))} <HelpText text={translation(helptext)} /></span>

          <Check name='Noti_Email' value={key2} checked={checkedEmail[key2]} onChange={this.onCheck} disabled={employee.Email === null || employee.Email.length === 0} simple />

          {val.NotificationEvent !== 16 && (val.NotificationEvent < 100 || val.NotificationEvent >= 150) && (
            <Check name='Noti_Sms' value={key2} checked={checkedSms[key2]} onChange={this.onCheck} disabled={employee.Phone === null || employee.Phone.length === 0} simple width='1' />
          ) || (
            <span />
          )}
        </Grid>
      )
    }

    const sortPaintNotifications = (a, b) => {
      const nEventA = a.NotificationEvent
      const nEventB = b.NotificationEvent

      // Sort to top
      const topSpecialValues = [7, 17, 1, 19]
      const isTopSpecialA = topSpecialValues.includes(nEventA)
      const isTopSpecialB = topSpecialValues.includes(nEventB)
      if (isTopSpecialA) {
        if (!isTopSpecialB) {
          return -1
        } else {
          return topSpecialValues.indexOf(nEventA) - topSpecialValues.indexOf(nEventB)
        }
      } else if (isTopSpecialB) {
        return 1
      }

      // Sort to just above 21
      const bottomSpecialValues = [10, 11]
      const isBottomSpecialA = bottomSpecialValues.includes(nEventA)
      const isBottomSpecialB = bottomSpecialValues.includes(nEventB)
      if (isBottomSpecialA) {
        if (nEventB === 21) {
          return -1
        } else if (!isBottomSpecialB) {
          return 1
        }
      } else if (isBottomSpecialB) {
        if (nEventA === 21) {
          return 1
        } else {
          return -1
        }
      }

      return nEventA - nEventB
    }

    const sortBodyNotifications = (a, b) => {
      const nEventA = a.NotificationEvent
      const nEventB = b.NotificationEvent

      // Move event 17, 19 and 20 just after 1
      const specialValues = [17, 19, 20]
      const isSpecialA = specialValues.includes(nEventA)
      const isSpecialB = specialValues.includes(nEventB)
      if (isSpecialA) {
        if (nEventB === 1) {
          return 1
        } else if (!isSpecialB) {
          return -1
        }
      } else if (isSpecialB) {
        if (nEventA === 1) {
          return -1
        } else {
          return 1
        }
      }

      return nEventA - nEventB
    }

    var notificationEventType = []
    for (var i = 1; i < Object.keys(this.props.notificationEventType).length + 1; i++) {
      notificationEventType.push(this.props.notificationEventType[i])
    }

    if (employee.Department === 1) {
      // Sort for BodyShop
      employee.NotificationSettings.sort(sortBodyNotifications)
    } else {
      employee.NotificationSettings.sort(sortPaintNotifications)
    }

    // separate body shop employee notifications into 2 sections
    let isBodyShopEmployee = employee.Department === 1

    const notificationGroups = employee.NotificationSettings.reduce((list, notif) => {
      if (notif.Group === 1) {
        if (isBodyShopEmployee) {
          if ([1, 2, 3, 4, 5, 6, 13, 18].includes(notif.NotificationEvent)) {
            return { ...list, orderBodyPaint: [...list.orderBodyPaint, notif] } // Notifications between paint and boydy
          } else if ([9, 10, 11, 16, 17, 19, 20].includes(notif.NotificationEvent)) {
            return { ...list, order: [...list.order, notif] } // Internal body notifications
          } else {
            return list
          }
        } else {
          return { ...list, order: [...list.order, notif] }
        }
      } else if (notif.Group === 2) {
        return { ...list, refOrder: [...list.refOrder, notif] }
      } else if (notif.Group === 4) {
        return { ...list, bookingPortal: [...list.bookingPortal, notif] }
      } else {
        return { ...list, copy: [...list.copy, notif] }
      }
    }, { order: [], orderBodyPaint: [], refOrder: [], copy: [], bookingPortal: [] })

    const orderNotif = notificationGroups.order
    const orderBodyPaintNotif = notificationGroups.orderBodyPaint
    const refNotif = notificationGroups.refOrder
    const copyNotif = notificationGroups.copy
    const bookingPortalNotif = notificationGroups.bookingPortal

    var title = this.state.employee.Department !== 0 ? '13461' : '14947'

    const renderNotificationsCopy = () => {
      if (!hasSubscriptionPermission(this.props.auth, 30)) return null
      if (this.state.type === 'create') return null

      return (
        <div>
          <PanelHeader text={translation(title)} />
          <Grid cols={[ 4 ]} align='center' spacing={1}>
            <span />
            <span>{translation('1052')}</span>
            <span />
          </Grid>
          {copyNotif.map(NotificationEventTypeList)}
        </div>
      )
    }

    const renderReferredNotifications = () => {
      if (!hasSubscriptionPermission(this.props.auth, 30)) return null

      return (
        <div>
          <PanelHeader text={translation('15356')} />
          <Grid cols={[ 4 ]} align='center' spacing={1}>
            <span />
            <span>{translation('1052')}</span>
            <span>{translation('15')}</span>
          </Grid>
          {refNotif.map(NotificationEventTypeList)}
        </div>
      )
    }

    const renderBookingPortalNotifications = () => {
      if (!hasSubscriptionPermission(this.props.auth, 30)) return null

      return (
        <div>
          <PanelHeader text={translation('17957')} />
          <Grid cols={[ 4 ]} align='center' spacing={1}>
            <span />
            <span>{translation('1052')}</span>
            <span>{translation('15')}</span>
          </Grid>
          {bookingPortalNotif.map(NotificationEventTypeList)}
        </div>
      )
    }

    return (
      <Panel title={translation('13461')} helpText={translation('1968')}>
        {isBodyShopEmployee && (
          <PanelHeader text={translation('15247')} />
        )}

        <Grid cols={[4]} align='center' spacing={1}>
          <span />
          <span>{translation('1052')}</span>
          <span>{translation('15')}</span>
        </Grid>
        {orderNotif.map(NotificationEventTypeList)}

        {!isBodyShopEmployee && renderReferredNotifications()}
        {!isBodyShopEmployee && renderNotificationsCopy()}

        {isBodyShopEmployee && (
          <div>
            <PanelHeader text={translation('15248')} />

            <Grid cols={[4]} align='center' spacing={1}>
              <span />
              <span>{translation('1052')}</span>
              <span>{translation('15')}</span>
            </Grid>

            {orderBodyPaintNotif.map(NotificationEventTypeList)}
          </div>
        )}

        {isBodyShopEmployee && renderReferredNotifications()}
        {isBodyShopEmployee && renderBookingPortalNotifications()}
      </Panel>
    )
  }

  renderPermissions () {
    // if (this.state.type === 'create') return null
    if (!hasSubscriptionPermission(this.props.auth, 10, 0)) return null
    let { Permissions } = this.state.employee
    if (typeof Permissions === 'undefined') {
      Permissions = [...this.props.auth.permissions.DefaultPermissions]
    }
    let newPermission = []
    Permissions.map((val) => {
      if (typeof newPermission[val.PermissionGroup] === 'undefined') {
        // console.log(val)
        newPermission[val.PermissionGroup] = {
          name: translation(enumtranslate('PermissionGroup', val.PermissionGroup)),
          items: []
        }
      }
      newPermission[val.PermissionGroup].items.push(val)
    })

    const renderGroup = (group, key) => {
      const onCheckBoxChange = (e) => {
        let employee = { ...this.state.employee }
        if (typeof employee.Permissions === 'undefined') {
          employee.Permissions = [...this.props.auth.permissions.DefaultPermissions]
        }

        group.items.map((val) => {
          for (let i = 0; i < employee.Permissions.length; i++) {
            if (employee.Permissions[i].Id === val.Id) {
              employee.Permissions[i].Checked = e.target.checked
            }
          }
        })
        if (employee.UserId === this.props.auth.user.UserId) {
          this.props.auth.permissions.EmployeePermissions = employee.Permissions.filter(x => x.Checked)
        }
        this.setState({
          employee: employee
        }, () => {
          if (this.state.type === 'edit') {
            this.saveAddEmployee('Permissions')
          }
        })
      }
      return (
        <div key={key}>
          <Check checked={group.items.every(x => x.Checked)} onChange={onCheckBoxChange} labelText={group.name} />
          {group.items.map(renderItem)}
          {key !== 3 && <Divider />}
        </div>
      )
    }

    const renderItem = (item, key) => {
      // No CarRentalOverview, SparePartsModule on PaintShops
      if (this.props.auth.departmentType !== 1 && [ 29, 31 ].includes(item.Id)) return null

      const onChange = (e) => {
        let employee = { ...this.state.employee }
        let permissions = [...employee.Permissions]
        permissions.map((val, k) => {
          if (val.Id === item.Id) {
            permissions[k] = {
              ...item,
              Checked: e.target.checked
            }
          }
        })
        if (employee.UserId === this.props.auth.user.UserId) {
          this.props.auth.permissions.EmployeePermissions = permissions.filter(x => x.Checked)
        }
        employee.Permissions = permissions
        this.setState({
          employee: employee
        }, () => {
          if (this.state.type === 'edit') {
            this.saveAddEmployee('Permissions')
          }
        })
      }
      let helpText = ''
      switch (item.Id) {
        case 1:
          helpText = '2175'
          break
        case 2:
          helpText = '2177'
          break
        case 3:
          helpText = '2176'
          break
        case 4:
          helpText = '2181'
          break
        case 5:
          helpText = '14717'
          break
        case 6:
          helpText = '2195'
          break
        case 7:
          helpText = hasSubscriptionPermission(this.props.auth, 20) ? '2191' : '15272'
          break
        case 8:
          helpText = '2194'
          break
        case 9:
          helpText = '2192'
          break
        case 10:
          helpText = ''
          break
        case 11:
          helpText = this.props.auth.departmentType !== 0 ? '2188' : '15233'
          if (!hasSubscriptionPermission(this.props.auth, 20)) helpText = '15270'
          break
        case 12:
          helpText = '2178'
          break
        case 13:
          helpText = '2187'
          break
        case 14:
          helpText = '2186'
          break
        case 15:
          helpText = '2185'
          break
        case 16:
          helpText = ''
          break
        case 17:
          helpText = hasSubscriptionPermission(this.props.auth, 20) ? '2193' : '15271'
          break
        case 18:
          helpText = ''
          break
        case 19:
          helpText = '2189'
          break
        case 20:
          helpText = '2180'
          break
        case 21:
          helpText = '2179'
          break
        case 22:
          helpText = '2184'
          break
        case 23:
          helpText = ''
          break
        case 24:
          helpText = '2190'
          break
        case 25:
          helpText = '2182'
          break
        case 26:
          helpText = '2183'
          break
        case 27:
          helpText = ''
          break
        case 28:
          helpText = ''
          break
        case 29:
          helpText = '15230'
          break
        case 31:
          helpText = '16479'
          break
        case 32:
          helpText = '16843'
          break
        case 33:
          helpText = '17983'
          break

      }
      return (
        <Check checked={item.Checked} onChange={onChange} labelText={translation(item.Name)} helpText={translation(helpText)} key={key} />
      )
    }

    return (
      <Panel title={translation('2149')}>
        {newPermission.map(renderGroup)}
      </Panel>
    )
  }

  renderMyWorkScreen () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    // if (this.state.type === 'create') return null
    if (this.props.paintShopOrderSteps === undefined || this.props.paintShopOrderSteps === null || this.props.paintShopOrderSteps.length === 0) {
      return
    }
    if (!hasSubscriptionPermission(this.props.auth, 10, 0)) return null
    let employee = this.state.employee
    // const paintShopOrderStepsList = (val, key) => {
    //   let id = 'PaintShopStep' + key
    //   let name = 'Step' + (key + 1)
    //   let workscreen = this.state.employee.MyWorkscreen
    //   if (workscreen === undefined) return
    //   if (this.props.auth.departmentType === 1 && val !== 164) return null
    //   return (
    //     <div className='checkbox__custom' key={key}>
    //       <input type='checkbox' id={id} value={key} checked={workscreen[name]} name={name} onChange={this.onCheck} />
    //       <label htmlFor={id} className='inputCheck' />
    //       <label>{translation(val)}</label>
    //     </div>
    //   )
    // }
    // const bodyShopOrderStepsList = (val, key) => {
    //   let keyIndex = (key + 1) + 100
    //   let name = 'Step' + keyIndex
    //   let workscreen = this.state.employee.MyWorkscreen
    //   if (workscreen === undefined) return
    //   console.log('bodystep', val, key)
    //   return (
    //     <div className='checkbox__custom' key={keyIndex}>
    //       <input type='checkbox' id={keyIndex} value={keyIndex} checked={workscreen[name]} name={name} onChange={this.onCheck} />
    //       <label htmlFor={keyIndex} className='inputCheck' />
    //       <label>{translation(val)}</label>
    //     </div>
    //   )
    // }
    var paintShopOrderSteps = []
    // var bodyShopOrderSteps = []
    // console.log('paintshop order steps', this.props.paintShopOrderSteps)
    for (var step in this.props.paintShopOrderSteps) {
      if (parseInt(step) === 0 || parseInt(step) === 8) { continue }
      let stepItem = this.props.paintShopOrderSteps[step]
      paintShopOrderSteps.push(stepItem)
      // if (step < 100) {
      //   paintShopOrderSteps.push(this.props.paintShopOrderSteps[step])
      // } else {
      //   bodyShopOrderSteps.push(this.props.paintShopOrderSteps[step])
      // }
    }
    const renderOrderSteps = () => {
      // Checkboxes der er synlige i forhold til integrationsskærmen.
      if (this.props.auth.departmentType === 2) {
        return (
          <div>
            {renderOrderStep(translation(164), 1)}
            {renderOrderStep(translation(617), 101)}
            {renderOrderStep(translation(618), 102)}
            {renderOrderStep(translation(619), 103)}
            {renderOrderStep(translation(162) + ' (' + translation(14779) + ')', 104)}
            {renderOrderStep(translation(163), 7)}
            <hr />
            {renderOrderStep(translation(96), 2)}
            {renderOrderStep(translation(160), 3)}
            {renderOrderStep(translation(158), 4)}
            {renderOrderStep(translation(161), 5)}
            {renderOrderStep(translation(162) + ' (' + translation(161) + ')', 6)}
          </div>
        )

        /*
        Old Return

         return (
          <div className='checklist'>
            {renderOrderStep(translation(164), 0)}
            {renderOrderStep(translation(617), 7)}
            {renderOrderStep(translation(618), 8)}
            {renderOrderStep(translation(619), 9)}
            {renderOrderStep(translation(162) + ' (' + translation(14779) + ')', 10)}
            {renderOrderStep(translation(163), 6)}
            <hr />
            {renderOrderStep(translation(96), 1)}
            {renderOrderStep(translation(160), 2)}
            {renderOrderStep(translation(158), 3)}
            {renderOrderStep(translation(161), 4)}
            {renderOrderStep(translation(162) + ' (' + translation(161) + ')', 5)}
          </div>
        )
        */
      }
      // Checkboxes der er synlige i forhold til karosseriskærmen.
      if (this.props.auth.departmentType === 1) {
        return (
          <div>
            {renderOrderStep(translation(164), 1)}
            {renderOrderStep(translation(617), 101)}
            {renderOrderStep(translation(618), 102)}
            {renderOrderStep(translation(619), 103)}
            {renderOrderStep(translation(162), 104)}
            {renderOrderStep(translation(163), 7)}
          </div>
        )
      }
      return (
        <div>
          {renderOrderStep(translation(164), 1)}
          {renderOrderStep(translation(96), 2)}
          {renderOrderStep(translation(160), 3)}
          {renderOrderStep(translation(158), 4)}
          {renderOrderStep(translation(161), 5)}
          {renderOrderStep(translation(162), 6)}
          {renderOrderStep(translation(163), 7)}
        </div>
      )
    }
    const renderOrderStep = (text, key) => {
      // let keyIndex = (key + 1) + 100
      let keyIndex = key
      let name = 'Step' + keyIndex
      let workscreen = this.state.employee.MyWorkscreen
      if (workscreen === undefined) return
      return (
        <Check id={name} value={keyIndex} checked={workscreen[name]} name={name} onChange={this.onCheck} labelText={text} key={keyIndex} />
      )
    }
    // {paintShopOrderSteps.map(paintShopOrderStepsList)}
    // <hr />
    // {bodyShopOrderSteps.map(bodyShopOrderStepsList)}
    return (
      <Panel title={translation('1857')} helpText={translation('1974')}>
        {renderOrderSteps()}

        <Switch name='WorkScreen_Active' checked={employee.MyWorkscreen.Active} onChange={this.onRadioChange} labelText={translation('295')} />
      </Panel>
    )
  }

  render () {
    // let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
    const showNotifications = (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20))

    const oneCol = 1008 // px
    const twoCols = 1328 // px
    const threeCols = 1648 // px
    const { width } = this.state.dimensions
    if (width > oneCol && width <= twoCols) {
      return (
        <div>
          <Col>
            {this.renderUser()}
            {this.renderSettings()}
            {showNotifications && this.renderNotifications()}
          </Col>
          <Col>
            {this.renderHours()}
            {this.renderPermissions()}
            {this.renderMyWorkScreen()}
          </Col>
        </div>
      )
    } else if (width > twoCols && width <= threeCols) {
      return (
        <div>
          <Col>
            {this.renderUser()}
            {this.renderSettings()}
          </Col>
          <Col>
            {this.renderHours()}
            {showNotifications && this.renderNotifications()}
          </Col>
          <Col>
            {this.renderPermissions()}
            {this.renderMyWorkScreen()}
          </Col>
        </div>
      )
    } else {
      return (
        <div>
          <Col>
            {this.renderUser()}
            {this.renderSettings()}
          </Col>
          <Col>
            {this.renderHours()}
          </Col>
          <Col>
            {this.renderPermissions()}
          </Col>
          <Col>
            {showNotifications && this.renderNotifications()}
            {this.renderMyWorkScreen()}
          </Col>
        </div>
      )
    }
  }

}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes,
    employeeTypes: state.common.enums_new.EmployeeTypes,
    notificationEventType: state.common.enums_new.NotificationEventType,
    paintShopOrderSteps: state.common.enums_new.PaintShopOrderSteps,
    companyDepartments: state.common.enums_new.CompanyDepartments
  }
}

export default connect(mapStateToProps, {
  getEmployee,
  CreateSaveEmployee,
  setLanguage,
  getLanguageInfos
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Employees/View/index.js